// eslint-disable-next-line
const UsaStates = require("usa-states").UsaStates;

// export const usaStates = new UsaStates({ includeTerritories: true }).states;
export const usaStates = new UsaStates().states;

export const usaStatesListItems = [
  { title: "Alabama", value: "Alabama" },
  { title: "Alaska", value: "Alaska" },
  { title: "Arizona", value: "Arizona" },
  { title: "Arkansas", value: "Arkansas" },
  { title: "California", value: "California" },
  { title: "Colorado", value: "Colorado" },
  { title: "Connecticut", value: "Connecticut" },
  { title: "Delaware", value: "Delaware" },
  { title: "Florida", value: "Florida" },
  { title: "Georgia", value: "Georgia" },
  { title: "Hawaii", value: "Hawaii" },
  { title: "Idaho", value: "Idaho" },
  { title: "Illinois", value: "Illinois" },
  { title: "Indiana", value: "Indiana" },
  { title: "Iowa", value: "Iowa" },
  { title: "Kansas", value: "Kansas" },
  { title: "Kentucky", value: "Kentucky" },
  { title: "Louisiana", value: "Louisiana" },
  { title: "Maine", value: "Maine" },
  { title: "Maryland", value: "Maryland" },
  { title: "Massachusetts", value: "Massachusetts" },
  { title: "Michigan", value: "Michigan" },
  { title: "Minnesota", value: "Minnesota" },
  { title: "Mississippi", value: "Mississippi" },
  { title: "Missouri", value: "Missouri" },
  { title: "Montana", value: "Montana" },
  { title: "Nebraska", value: "Nebraska" },
  { title: "Nevada", value: "Nevada" },
  { title: "New Hampshire", value: "New Hampshire" },
  { title: "New Jersey", value: "New Jersey" },
  { title: "New Mexico", value: "New Mexico" },
  { title: "New York", value: "New York" },
  { title: "North Carolina", value: "North Carolina" },
  { title: "North Dakota", value: "North Dakota" },
  { title: "Ohio", value: "Ohio" },
  { title: "Oklahoma", value: "Oklahoma" },
  { title: "Oregon", value: "Oregon" },
  { title: "Pennsylvania", value: "Pennsylvania" },
  { title: "Rhode Island", value: "Rhode Island" },
  { title: "South Carolina", value: "South Carolina" },
  { title: "South Dakota", value: "South Dakota" },
  { title: "Tennessee", value: "Tennessee" },
  { title: "Texas", value: "Texas" },
  { title: "Utah", value: "Utah" },
  { title: "Vermont", value: "Vermont" },
  { title: "Virginia", value: "Virginia" },
  { title: "Washington", value: "Washington" },
  { title: "West Virginia", value: "West Virginia" },
  { title: "Wisconsin", value: "Wisconsin" },
  { title: "Wyoming", value: "Wyoming" },
  { title: "District of Columbia", value: "District of Columbia" },
];
